import { theme, Typography } from 'antd';

const FormMainLabel = ({
  index,
  label,
}: {
  index?: string | number;
  label: string;
}) => {
  const { useToken } = theme;
  const { token } = useToken();
  return (
    <Typography.Title
      level={5}
      style={{
        fontSize: '18px',
        color: token.colorTextLabel,
        marginTop: '0rem',
      }}
    >
      {index ? `${index}. ${label}` : label}
    </Typography.Title>
  );
};

export default FormMainLabel;
